module.exports = __webpack_public_path__ + "img/voice-thumb10.ba377b4.jpg";